import React, { createContext, useState } from 'react';
import Step from './Step';
import Stepper from './Stepper';

export const PartnerContext = createContext();

function Context() {
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [formData, setFormData] = useState({});
  return (
    <PartnerContext.Provider value={{ activeStepIndex, setActiveStepIndex, formData, setFormData }}>
      <Stepper />
      <Step />
    </PartnerContext.Provider>
  );
}

export default Context;
